import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles';

/* WARNING: Works properly if pararent DIV has position defined */
/** * Stateless component to draw DotBadge.
* @param {boolean} animated Animated bounce trigger.
 * @returns {JSX} Component DotBadge JSX.
 */
class DotBadge extends Component {
  constructor(...props) {
    super(...props);
  }

  render() {
    const { animated, color } = this.props;
    return (
      <>
      <span className={`dotBadge${animated ? ' bounce' : ''} ${color}`} />
      <style jsx>{styles}</style>
      </>
    );
  }
}

DotBadge.propTypes = {
  animated: PropTypes.bool,
  color: PropTypes.string,
};

DotBadge.defaultProps = {
  animated: true,
  color: 'red',
}

export default DotBadge;
